import { useAtomValue } from "jotai";
import { type ReactNode, useState } from "react";

import { Icon } from "@frontend/components/atoms/Icon";
import { Input } from "@frontend/components/atoms/Input";
import { useDebouncedCallback } from "@frontend/hooks/useDebouncedCallback";
import { useLingui } from "@lingui/react/macro";

import { useAddressBookActions } from "../../hooks/useAddressBookActions";
import { searchQueryAtom } from "../../stores";

const SEARCH_DEBOUNCE = 200;

export function Search({
  rightSection,
}: {
  readonly rightSection?: ReactNode;
}) {
  const { t } = useLingui();

  const { setSearchQuery } = useAddressBookActions();

  const query = useAtomValue(searchQueryAtom);

  const [typed, setTyped] = useState(query);

  const searchLater = useDebouncedCallback(setSearchQuery, SEARCH_DEBOUNCE);

  const [applied, setApplied] = useState(query);

  if (query !== applied) {
    setApplied(query);
    setTyped(query);
  }

  return (
    <Input
      type="search"
      placeholder={t`Search contacts...`}
      value={typed}
      onValueChange={(next) => {
        setTyped(next);
        searchLater(next);
      }}
      leftSection={<Icon name="Search" size="sm" />}
      rightSection={rightSection}
    />
  );
}
